module.exports = __webpack_public_path__ + "static/media/assignTaskGrey@3x.b5556847.png";